module.exports = "## Radio Button\n\n[Radio buttons](https://www.google.com/design/spec/components/selection-controls.html#selection-controls-radio-button)\nare switches used for selection from multiple options.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/RadioButton/README.md
 ** module id = 1032
 ** module chunks = 0
 **/